import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

// Thunks

export const fetchAnnouncements = createAsyncThunk(
  'layout/fetchAnnouncements',
  async () => {
    const data = await api.fetchAnnouncements();
    return data;
  },
);

// Slice

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    open: true,
    loading: false,
    success: false,
    announcements: [],
  },
  reducers: {
    openDrawer: (state) => {
      state.open = true;
    },
    closeDrawer: (state) => {
      state.open = false;
    },
    changeLoadingStatus: (state, action) => {
      state.loading = action.payload;
    },
    changeSuccessStatus: (state, action) => {
      state.success = action.payload;
    },
  },
  extraReducers: {
    [fetchAnnouncements.fulfilled]: (state, action) => {
      state.announcements = action.payload;
    },
  },
});

// Actions

export const {
  changeLoadingStatus,
  changeSuccessStatus,
  setSuccessStatus,
  openDrawer,
  closeDrawer,
  markAsLoading,
  markAsLoaded,
} = layoutSlice.actions;

// Selectors

export const selectOpen = (state) => state.layout.open;
export const selectLoading = (state) => state.layout.loading;
export const selectSuccess = (state) => state.layout.success;
export const selectAnnouncements = (state) => state.layout.announcements;
export const selectNumberOfNotifications = (state) => state.layout.announcements.length;

// Reducer

export default layoutSlice.reducer;
